import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { googleTrackPageView } from './google';
import { pixelTrackTruePageView } from './fb_pixel';
import { useMixpanel } from 'react-mixpanel-browser';
import { mixPanelTrackPageView } from './mixpanel';

export default function WithTracker(WrappedComponent, options = {}) {
  const trackPage = (page, qstring, hash, mixPanel) => {
    const fullRoute = page + qstring + hash;

    // All analytics trackers should be triggered here, for page views.
    mixPanelTrackPageView(mixPanel, fullRoute);
    googleTrackPageView(fullRoute);
    pixelTrackTruePageView(fullRoute);
  };

  const HOC = (props) => {
    const location = useLocation();
    const mixPanel = useMixpanel();
    // Important Note: The cart may be found inside the dependency list,
    // but in fact, this useEffect is expected to only run when the location
    // changes. The cart is expected to remain the same throughout.
    useEffect(() => {
      trackPage(location.pathname, location.search, location.hash, mixPanel);
    }, [location, mixPanel]);

    return <WrappedComponent {...props} />;
  };

  HOC.displayName = 'WithTrackerInternalHOC';
  return HOC;
}
